import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ResetErrors, SetError, SetIsOwnError } from '../actions/errors.action';

export interface ErrorsStateModel {
    errors: any[];
    isOwnError: boolean;
}

@State<ErrorsStateModel>({
    name: 'errors',
    defaults: {
        errors: [],
        isOwnError: false,
    },
})
@Injectable()
export class ErrorsState {
    @Selector()
    public static errors(state: ErrorsStateModel): any[] {
        return state.errors;
    }

    @Selector()
    public static isOwnError(state: ErrorsStateModel): boolean {
        return state.isOwnError;
    }

    @Action(SetError)
    public setError(ctx: StateContext<ErrorsStateModel>, action: SetError): void {
        const errors: any[] = ctx.getState().errors;
        if (Array.isArray(action.error)) {
            ctx.patchState({
                errors: [...errors, ...action.error],
            });
        } else {
            ctx.patchState({
                errors: [...errors, action.error],
            });
        }
    }

    @Action(SetIsOwnError)
    public setIsOwnError(ctx: StateContext<ErrorsStateModel>): void {
        ctx.patchState({
            isOwnError: true,
        });
    }

    @Action(ResetErrors)
    public resetErrors(ctx: StateContext<ErrorsStateModel>): void {
        ctx.patchState({
            errors: [],
            isOwnError: false,
        });
    }
}
